export interface QuicktipState {
    quicktipData: any;
    loading: boolean;
    error: null | string;
}


export enum QuicktipActionTypes {
    FETCH_QUICKTIP_DATA = "FETCH_QUICKTIP_DATA",
    FETCH_QUICKTIP_DATA_SUCCESS = "FETCH_QUICKTIP_DATA_SUCCESS",
    FETCH_QUICKTIP_DATA_ERROR = "FETCH_QUICKTIP_DATA_ERROR",
}

export type QuicktipAction =
    | { type: QuicktipActionTypes.FETCH_QUICKTIP_DATA }
    | { type: QuicktipActionTypes.FETCH_QUICKTIP_DATA_SUCCESS; payload: any[] }
    | { type: QuicktipActionTypes.FETCH_QUICKTIP_DATA_ERROR; payload: string };